import { render, staticRenderFns } from "./votoEsame.vue?vue&type=template&id=604e7ff9&"
import script from "./votoEsame.vue?vue&type=script&lang=js&"
export * from "./votoEsame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports